// extracted by mini-css-extract-plugin
export default {"FontContainer":"FontSelect_FontContainer__qQpN8","Title":"FontSelect_Title__l7jJo"};